import { makeStyles } from "@material-ui/core"

export default makeStyles(() => ({
    menuItem: {
        // backgroundColor: '#fff',
        "&.active": {
            "& .MuiListItemIcon-root": {
                color: "#fff"
            }
        },
        "&:hover": {
            backgroundColor: "#f3f3f3"
        }
    },
    menuItemIcon: {
        color: "#97c05c"
    },
    button: {
        justifyContent: "flex-start",
        color: "#404040"
    },
    icon: {
        display: "inline-block"
    },
    openTransform: {
        transform: "rotate(180deg)"
    },
    categoryArea: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        "&:hover": {
            backgroundColor: "#f3f3f3"
        }
    }
}))
